import SectionTitle from "@/components/base/SectionTitle";
import PostCard from "@/components/base/PostCard";
import HotSidebar from "@/components/feature/HotSidebar";
import { posts } from "@/mocks/community";

export default function LatestSection() {
  const latest = [...posts].sort((a, b) => (a.publishedAt < b.publishedAt ? 1 : -1)).slice(0, 5);

  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-container px-4 md:px-6">
        <div className="grid gap-8 lg:grid-cols-[1.7fr_1fr]">
          <div>
            <SectionTitle
              eyebrow="新帖速递"
              title="新帖热门讨论随时刷"
              desc="刚刚发布就有人在回的新帖，往往藏着接下来会火的话题。"
            />
            <div className="space-y-4">
              {latest.map((post) => (
                <PostCard key={post.id} post={post} variant="wide" />
              ))}
            </div>
          </div>
          <HotSidebar />
        </div>
      </div>
    </section>
  );
}